export const selectColumnList = [
  { optionKey: "Select Column", optionValue: "" },
  { optionKey: "Option 1", optionValue: "1" },
  { optionKey: "Option 2", optionValue: "2" },
  { optionKey: "Option 3", optionValue: "3" },
];

export const sortByOptionList = [
  { optionKey: "Sort By Option", optionValue: "" },
  { optionKey: "Option 1", optionValue: "1" },
  { optionKey: "Option 2", optionValue: "2" },
  { optionKey: "Option 3", optionValue: "3" },
];

export const showRowsList = [
  { optionKey: "Select Rows", optionValue: "" },
  { optionKey: "10", optionValue: 10 },
  { optionKey: "50", optionValue: 50 },
  { optionKey: "100", optionValue: 100 },
  { optionKey: "500", optionValue: 500 },
  { optionKey: "2000", optionValue: 2000 },
];
